import { getAddressDetails, getAddressesLookup } from './addressService';
import { default as permitService } from './permitService';
import { sendFeedback } from './feedbackService';

const addressService = {
  getAddressDetails,
  getAddressesLookup
};

export { addressService, permitService, sendFeedback };
